import { apiProxyRequest } from "Api/apiProxyRequest";

export const deleteProjectAddon = ({
  organizationId,
  projectId,
  addonId
}: {
  organizationId: string;
  projectId: string;
  addonId: string;
}) =>
  apiProxyRequest<void>(
    `/organizations/${organizationId}/projects/${projectId}/addons/${addonId}`,
    "DELETE"
  );
